import "./NewsFilter.scss";

export default {
  name: "NewsFilter",
  props: ["value", "issues", "channels", "features", "users"],
  components: {},
  data: () => ({
    currentFilterUserId: ""
  }),
  mounted() {},
  methods: {
    resetFilter() {
      this.$emit("input", {
        issueId: "",
        creatorId: "",
        channels: "",
        featureIds: "",
        deleted: false
      });
      this.$emit("filterChanged");
    },
    setUserIdsInFilter(id) {
      if (id) {
        const foundUser = this.users.find(user => user.id === id);
        if (foundUser?._id)
          this.value.creatorId = { $in: [foundUser._id, foundUser.id] };
        else this.value.creatorId = { $in: [id] };
      } else {
        this.value.creatorId = "";
      }
      this.$emit("filterChanged");
    }
  },
  computed: {
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    newsEditor() {
      return this.$store.state.currentUser?.scopes.includes("role:news_editor");
    },
    newsAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:news_admin");
    }
  }
};
